import React, { useEffect } from "react";
import DatePicker from "react-multi-date-picker";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { setEndDate, setStartDate } from "../../redux/slices/atpSlice";

const DateRangePickerComponent = () => {
    const startDate = useSelector((state) => state.atp.startDate);
    const endDate = useSelector((state) => state.atp.endDate);
    const dispatch = useDispatch();
    const userType = useSelector((state) => state.auth?.user?.user_type);

    const pickerDisplay = (d) =>
        d != null && d !== "" && moment(d).isValid() ? moment(d).format("DD/MM/YYYY") : "";
    // Function to get the start and end dates of the current week
    const getCurrentWeekDates = () => {
        const currentDate = new Date();
        const startDate = new Date(currentDate.getFullYear(), 0, 1);
        const endDate = new Date(currentDate);
        return { startDate, endDate };
    };

    // useEffect(() => {
    //   const { startDate, endDate } = getCurrentWeekDates();
    //   const formattedStartDate = moment(startDate).format(
    //     "YYYY-MM-DDTHH:mm:ss.SSS[Z]"
    //   );
    //   const formattedEndDate = moment(endDate).format(
    //     "YYYY-MM-DDTHH:mm:ss.SSS[Z]"
    //   );
    //   dispatch(setStartDate(formattedStartDate));
    //   dispatch(setEndDate(formattedEndDate));
    // }, []);
    useEffect(() => {
        // const { startDate, endDate } = getCurrentWeekDates();
        if (userType === 3) {
            const { startDate, endDate } = getCurrentWeekDates();
            const formattedStartDate = moment(startDate).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
            const formattedEndDate = moment(endDate).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
            dispatch(setStartDate(formattedStartDate));
            dispatch(setEndDate(formattedEndDate));
        } else {
            if (startDate === "Invalid date" && endDate === "Invalid date") {
                dispatch(setStartDate(null));
                dispatch(setEndDate(null));
            } else {
                // dispatch(setStartDate(moment(startDate).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")));
                // dispatch(setEndDate(moment(endDate).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")));
            }
        }
    }, [dispatch]);

    return (
        <div
            className="center-alignment start-date"
            style={{
                borderRadius: "8px",
                border: "1px solid #C3D3E2",
                // height: "40px",
                padding: "0px 5px",
            }}
        >
            {/* Start Date */}
            <DatePicker
                className="custom-datepicker"
                value={pickerDisplay(startDate)}
                onChange={(value) => {
                    const formattedDate = new Date(value).toISOString();
                    dispatch(setStartDate(moment(formattedDate)?.format("YYYY-MM-DD")));
                }}
                headerOrder={["MONTH_YEAR", "LEFT_BUTTON", "RIGHT_BUTTON"]}
                format="DD/MM/YYYY"
                editable={false}
                placeholder="DD-MM-YYYY"
                months={["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]}
            />
            <span> - </span>
            {/* End Date */}
            <DatePicker
                className="custom-datepicker"
                value={pickerDisplay(endDate)}
                onChange={(value) => {
                    const formattedDate = new Date(value).toISOString();
                    dispatch(setEndDate(moment(formattedDate)?.format("YYYY-MM-DD")));
                }}
                headerOrder={["MONTH_YEAR", "LEFT_BUTTON", "RIGHT_BUTTON"]}
                format="DD/MM/YYYY"
                editable={false}
                minDate={pickerDisplay(startDate) || undefined}
                placeholder="DD-MM-YYYY"
                months={["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]}
            />
        </div>
    );
};

export default DateRangePickerComponent;
